export default {
  setCountryZones(state, countryZones) {
    state.countryZones = countryZones
  },

  setInCountryZones(state, inCountryZones) {
    state.inCountryZones = inCountryZones
  },

  addCountryZone(state, countryZone) {
    state.countryZones.push(countryZone)
  },

  removeCountryZone(state, countryZoneForRemove) {
    let predicate = null
    const type = typeof countryZoneForRemove
    if (type === 'string' || type === 'number')
      predicate = zone => zone.id !== countryZoneForRemove.id
    else if (type === 'object')
      predicate = zone => zone !== countryZoneForRemove
    else throw new Error('Invalid predicate or invalid type')

    state.countryZones = state.countryZones.filter(predicate)
  },

  removeInCountryZone(state, inCountryZoneForRemove) {
    let predicate = null
    const type = typeof inCountryZoneForRemove
    if (type === 'string' || type === 'number')
      predicate = zone => zone.id !== inCountryZoneForRemove.id
    else if (type === 'object')
      predicate = zone => zone !== inCountryZoneForRemove
    else throw new Error('Invalid predicate or invalid type')

    state.inCountryZones = state.inCountryZones.filter(predicate)
  },

  addInCountryZone(state, inCountryZone) {
    state.inCountryZones.push(inCountryZone)
  },

  toggleZoneManagerPanelVisibility(state) {
    state.isZoneManagerPanelOpen = !state.isZoneManagerPanelOpen
  },

  setActiveCountryZone(state, countryZone) {
    state.activeCountryZone = countryZone
  },

  unsetActiveCountryZone(state) {
    state.activeCountryZone = null
  },

  setActiveInCountryZone(state, inCountryZone) {
    state.activeInCountryZone = inCountryZone
  },

  unsetActiveInCountryZone(state) {
    state.activeInCountryZone = null
  },

  updateCountryZones(state, countryZone) {
    state.countryZones = state.countryZones.map(zone =>
      zone.id === countryZone.id ? countryZone : zone,
    )
  },

  updateInCountryZones(state, inCountryZone) {
    state.inCountryZones = state.inCountryZones.map(zone =>
      zone.id === inCountryZone.id ? inCountryZone : zone,
    )
  },

  setCurrentDivision(state, division) {
    let currentDivision = {
      id: division.id,
      title: division.title,
    }

    state.currentDivision = currentDivision
    localStorage.setItem(
      `taxi-admin.current-division`,
      JSON.stringify(currentDivision),
    )
  },

  setAllDivisions(state) {
    let currentDivision = {
      id: null,
      title: null,
    }

    state.currentDivision = currentDivision
    localStorage.setItem(
      `taxi-admin.current-division`,
      JSON.stringify(currentDivision),
    )
  },
}
